// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"397abbb4","240":"d28041e5","455":"3bef4cb2","515":"9bbe8067","638":"1c13e7be","944":"cf6c53b3","977":"240addac"}[chunkId] + ".chunk.js";
};